const InteractiveBannersData01 = [
    {
        subtitle: "Branding",
        title: "Leading branding agency based in washington",
        btnLink: "/blogs/blog-post-layout-01",
        img: "/assets/img/webp/transparent.webp",
        icon: "line-icon-Arrow-OutRight"
    },
    {
        subtitle: "Designing",
        title: "Creative design agency working for huge brands",
        btnLink: "/blogs/blog-post-layout-02",
        img: "/assets/img/webp/transparent.webp",
        icon: "line-icon-Arrow-OutRight"
    },
    {
        subtitle: "Development",
        title: "Development is the process of build websites",
        btnLink: "/blogs/blog-post-layout-03",
        img: "/assets/img/webp/transparent.webp",
        icon: "line-icon-Arrow-OutRight"
    },
    {
        subtitle: "Marketing",
        title: "Reach your ideal customers on the largest network",
        btnLink: "/blogs/blog-post-layout-04",
        img: "/assets/img/webp/transparent.webp",
        icon: "line-icon-Arrow-OutRight"
    }
]

const InteractiveBannersData02 = [
    {
        subtitle: "Flexible",
        title: "Bundle of layout type different layout",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Learn more",
        btnLink: "/page/about-us"
    },
    {
        subtitle: "Unique",
        title: "We are delivering beautiful products",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Learn more",
        btnLink: "/page/about-us"
    },
    {
        subtitle: "Responsive",
        title: "True responsiveness modern responsive",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Learn more",
        btnLink: "/page/about-us"
    },
    {
        subtitle: "Modern",
        title: "Beautiful and modern latest page builder",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Learn more",
        btnLink: "/page/about-us"
    },
    {
        subtitle: "Flexible",
        title: "Bundle of layout type different layout",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Learn more",
        btnLink: "/page/about-us"
    },
    {
        subtitle: "Unique",
        title: "We are delivering beautiful products",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Learn more",
        btnLink: "/page/about-us"
    },
    {
        subtitle: "Responsive",
        title: "True responsiveness modern responsive",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Learn more",
        btnLink: "/page/about-us"
    },
]

const InteractiveBannersData03 = [
    {
        title: "Build perfect websites",
        subtitle: "Custom shortcodes",
        img: "/assets/img/jpg/FacadeCleaning2_420.jpg",
        imgLink: "/page/pricing-packages",
        btnTitle: "Get started now",
        btnLink: "/page/contact-classic",
        titleLink: "#",
        icon: "fas fa-arrow-right"
    },
    {
        title: "Online website builder",
        subtitle: "Modern framework",
        img: "/assets/img/jpg/Flooring_420.jpg",
        imgLink: "/page/pricing-packages",
        btnTitle: "Get started now",
        titleLink: "#",
        btnLink: "/page/contact-classic",
        icon: "fas fa-arrow-right"
    },
    {
        title: "Different layout type",
        subtitle: "Different layout",
        img: "/assets/img/jpg/guesthouse420.jpg",
        imgLink: "/page/pricing-packages",
        btnTitle: "Get started now",
        titleLink: "#",
        btnLink: "/page/contact-classic",
        icon: "fas fa-arrow-right"
    },
    {
        title: "Elegant Unique design",
        subtitle: "True responsiveness",
        img: "/assets/img/jpg/KitchenChimney1_420.jpg",
        imgLink: "/page/pricing-packages",
        btnTitle: "Get started now",
        titleLink: "#",
        btnLink: "/page/contact-classic",
        icon: "fas fa-arrow-right"
    }
]

const InteractiveBannersData04 = [
    {
        title: 'Website design',
        content: "Lorem ipsum dolor consectetur adipiscing elit do eiusmod tempor incididunt ut labore dolore",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Explore services",
        btnLink: "/page/our-services",
        icon: "line-icon-Add-Window"
    },
    {
        title: "eCommerce experience",
        content: "Lorem ipsum dolor consectetur adipiscing elit do eiusmod tempor incididunt ut labore dolore",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Explore services",
        btnLink: "/page/our-services",
        icon: "line-icon-Add-Bag"
    },
    {
        title: "Digital platform",
        content: "Lorem ipsum dolor consectetur adipiscing elit do eiusmod tempor incididunt ut labore dolore",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Explore services",
        btnLink: "/page/our-services",
        icon: "line-icon-Android-Store"
    },
    {
        title: "Interface design",
        content: "Lorem ipsum dolor consectetur adipiscing elit do eiusmod tempor incididunt ut labore dolore",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Explore services",
        btnLink: "/page/our-services",
        icon: "line-icon-Cursor-Click2"
    }
]

const InteractiveBannersData05 = [
    {
        title: "Senior web designer",
        subtitle: "2 position open",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Apply now",
        btnLink: "/page/contact-simple",
        icon: "ti-user"
    },
    {
        title: "SENIOR DEVELOPER",
        subtitle: "3 position open",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Apply now",
        btnLink: "/page/contact-simple",
        icon: "ti-user"
    },
    {
        title: "UX design developer",
        subtitle: "4 position open",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Apply now",
        btnLink: "/page/contact-simple",
        icon: "ti-user"
    }
]

const InteractiveBannersData06 = [
    {
        title: "wedding",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Portfolio",
        btnLink: "/portfolio/portfolio-justified-gallery",
        imgLink: "#"
    },
    {
        title: "product",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Portfolio",
        btnLink: "/portfolio/portfolio-justified-gallery",
        imgLink: "#"
    },
    {
        title: "outdoor",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Portfolio",
        btnLink: "/portfolio/portfolio-justified-gallery",
        imgLink: "#"
    }
]

const InteractiveBannersData07 = [
    {
        country: "India",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Explore tours",
        btnLink: "#",
        imgLink: "#"
    },
    {
        country: "London",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Explore tours",
        btnLink: "#",
        imgLink: "#"
    },
    {
        country: "Australia",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Explore tours",
        btnLink: "#",
        imgLink: "#"
    },
    {
        country: "Portugal",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Explore tours",
        btnLink: "#",
        imgLink: "#"
    },
    {
        country: "Africa",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Explore tours",
        btnLink: "#",
        imgLink: "#"
    },
    {
        country: "Italy",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Explore tours",
        btnLink: "#",
        imgLink: "#"
    },
    {
        country: "Nepal",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Explore tours",
        btnLink: "#",
        imgLink: "#"
    },
    {
        country: "Indonesia",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "Explore tours",
        btnLink: "#",
        imgLink: "#"
    }
]

const InteractiveBannersData08 = [
    {
        img: "/assets/img/webp/transparent.webp",
        title: "The trescoat spa resort",
        country: "Africa",
        btnLink: "#",
        imgLink: "#"
    },
    {
        img: "/assets/img/webp/transparent.webp",
        country: "Thailand",
        title: "Moongo spa resort",
        btnLink: "#",
        imgLink: "#"
    },
    {
        img: "/assets/img/webp/transparent.webp",
        title: "Grand canyon baloon",
        country: "Singapore",
        btnLink: "#",
        imgLink: "#"
    }
]

const InteractiveBannersData09 = [
    {
        img: "/assets/img/webp/transparent.webp",
        title: "Discover forest",
        subtitle: "+990 Destinations",
        btnTitle: "Explore all tour",
        btnLink: "#"
    },
    {
        img: "/assets/img/webp/transparent.webp",
        title: "Mountain madness",
        subtitle: "+650 Destinations",
        btnTitle: "Explore all tour",
        btnLink: "#"
    },
    {
        img: "/assets/img/webp/transparent.webp",
        title: "Unexplored beaches",
        subtitle: "+250 Destinations",
        btnTitle: "Explore all tour",
        btnLink: "#"
    },
    {
        img: "/assets/img/webp/transparent.webp",
        title: "Romantic getaways",
        subtitle: "+350 Destinations",
        btnTitle: "Explore all tour",
        btnLink: "#"
    }
]

const InteractiveBannersData10 = [
    {
        img: "/assets/img/png/gym-img5.png",
        title: "RUNNING HAPPINESS",
        subtitle: "CREATED TO SUPPORT",
        btnTitle: "Explore more",
        btnLink: "#"
    },
    {
        img: "/assets/img/png/gym-img4.png",
        title: "FITNESS JOURNEY",
        subtitle: "FEMINIST OVER POWER",
        btnTitle: "Explore more",
        btnLink: "#"
    },
    {
        img: "/assets/img/png/gym-img6.png",
        title: "MAINTAIN FITNESS",
        subtitle: "SPORT HAPPINESS FANTASY",
        btnTitle: "Explore more",
        btnLink: "#"
    },
    {
        img: "/assets/img/png/gym-img7.png",
        title: "POSSIBLE EXERCISE",
        subtitle: "POWER OVERWHELMING",
        btnTitle: "Explore more",
        btnLink: "#"
    }
]

const InteractiveBannersData12 = [
    {
        title: "Design solutions",
        content: "Lorem ipsum dolor sit consectetur adipiscing sed eiusmod tempor.",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "View more",
        btnLink: "#",
        icon: "fas fa-angle-right"
    },
    {
        title: "Walls painting",
        content: "Lorem ipsum dolor sit consectetur adipiscing sed eiusmod tempor.",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "View more",
        btnLink: "#",
        icon: "fas fa-angle-right"
    },
    {
        title: "Interior decoration",
        content: "Lorem ipsum dolor sit consectetur adipiscing sed eiusmod tempor.",
        img: "/assets/img/webp/transparent.webp",
        btnTitle: "View more",
        btnLink: "#",
        icon: "fas fa-angle-right"
    },
]

const InteractiveBannersData13 = [
    {
        title: "Scott armchair",
        img: "/assets/img/webp/transparent.webp",
        icon: "line-icon-Arrow-OutRight"
    },
    {
        title: "Portable table",
        img: "/assets/img/webp/transparent.webp",
        icon: "line-icon-Arrow-OutRight"
    },
    {
        title: "Seating stool",
        img: "/assets/img/webp/transparent.webp",
        icon: "line-icon-Arrow-OutRight"
    },
    {
        title: "Rocking chair",
        img: "/assets/img/webp/transparent.webp",
        icon: "line-icon-Arrow-OutRight"
    },
]

const InteractiveBannersData14 = [
    {
        img: "/assets/img/webp/transparent.webp",
        title: "Honeymoon package",
        subtitle: "GET 50% OFF",
        content: "Lorem ipsum dolor amet adipiscing tempor",
        btnTitle: "Book Now",
        btnLink: "#"
    },
    {
        img: "/assets/img/webp/transparent.webp",
        title: "Cocktail package",
        subtitle: "GET 30% OFF",
        content: "Lorem ipsum dolor amet adipiscing tempor",
        btnTitle: "Book Now",
        btnLink: "#"
    },
    {
        img: "/assets/img/webp/transparent.webp",
        title: "Massage package",
        subtitle: "GET 50% OFF",
        content: "Lorem ipsum dolor amet adipiscing tempor",
        btnTitle: "Book Now",
        btnLink: "#"
    }
]

const InteractiveBannersData15 = [
    {
        img: "/assets/img/webp/transparent.webp",
        title: "Architecture design",
        content: "Lorem ipsum is simply dummy text of the printing and typesetting.",
        btnTitle: "See Portfolio",
        btnLink: "/portfolio/portfolio-boxed-metro"
    },
    {
        img: "/assets/img/webp/transparent.webp",
        title: "Structure design",
        content: "Lorem ipsum is simply dummy text of the printing and typesetting.",
        btnTitle: "See Portfolio",
        btnLink: "/portfolio/portfolio-boxed-metro"
    },
    {
        img: "/assets/img/webp/transparent.webp",
        title: "Furnitures design",
        content: "Lorem ipsum is simply dummy text of the printing and typesetting.",
        btnTitle: "See Portfolio",
        btnLink: "/portfolio/portfolio-boxed-metro"
    },
    {
        img: "/assets/img/webp/transparent.webp",
        title: "Landscape design",
        content: "Lorem ipsum is simply dummy text of the printing and typesetting.",
        btnTitle: "See Portfolio",
        btnLink: "/portfolio/portfolio-boxed-metro"
    },
]

export { InteractiveBannersData01, InteractiveBannersData02, InteractiveBannersData03, InteractiveBannersData04, InteractiveBannersData05, InteractiveBannersData06, InteractiveBannersData07, InteractiveBannersData08, InteractiveBannersData09, InteractiveBannersData10, InteractiveBannersData12, InteractiveBannersData13, InteractiveBannersData14, InteractiveBannersData15 }